import { ArrowForwardIos } from "@mui/icons-material";
import { FC, useEffect, useRef, useState } from "react";


export type TToggleCardData = {
    label: string;
    value: string;
    valueClasses?: string;
    icon: string;
}

const ToggleCard: FC<{
    list: TToggleCardData[],
    onClick: (val: boolean) => void;
}> = ({
    list,
    onClick,
}) => {

        const [collapse, setCollapse] = useState(false);
        const contentRef = useRef<HTMLDivElement>(null);
        const [contentHeight, setContentHeight] = useState("0px");

        useEffect(() => {
            if (!collapse && contentRef.current) {
                setContentHeight(`${contentRef.current.scrollHeight}px`);
            } else {
                setContentHeight("0px");
            }
        }, [collapse]);

        return (

            <div className="br-10 cursor-pointer border overflow-hidden">
                {" "}
                <div
                    onClick={() => {
                        onClick(!collapse);
                        setCollapse(!collapse);
                    }}
                    className={`flex gap-2 items-center px-4 py-2 ${collapse ? "" : "border-b"
                        } cursor-pointer`}
                    style={{ background: "#EBFFF0" }}
                >
                    <div
                        className="br-100 icon_bg w-[20px] h-[20px] flex items-center justify-center color-primary"
                        style={{
                            transition: "transform 0.5s ease-in-out",
                            transform: collapse ? "rotate(0deg)" : "rotate(90deg)",
                        }}
                    >
                        <ArrowForwardIos style={{ fontSize: 16 }} />
                    </div>

                    <span className="fs-14">Overview</span>
                </div>
                <div
                    ref={contentRef}
                    className="content bg-white"
                    style={{
                        maxHeight: contentHeight,
                        overflow: "hidden",
                        transition: "max-height 0.5s ease, opacity 0.5s ease",
                        opacity: collapse ? 0 : 1,
                    }}
                >
                    <div className="flex w-full divide-x">
                        {list.map((item, index) => (
                            <div
                                key={index}
                                className="flex items-center gap-2 px-2 py-4 w-2/5"
                            >
                                <img src={item.icon} alt="" className="h-8 w-8 object-contain" />
                                <div className="flex flex-col">
                                    <span className="fs-12 color-sub-text">{item.label}</span>
                                    <span className={`fs-14 ${item.valueClasses}`}>{item.value}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

export default ToggleCard;